var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"dark":""}},[(_vm.error.statusCode === 404)?_c('h1',[_vm._v("\n        "+_vm._s(_vm.pageNotFound)+"\n    ")]):_c('h1',[_vm._v("\n        "+_vm._s(_vm.otherError)+"\n    ")]),_vm._v(" "),_c('NuxtLink',{attrs:{"to":"/"}},[_vm._v("\n        Home page\n    ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }